import React from 'react';
import styled from 'styled-components';

import { mediaQueries } from '../shared/config'




const Credits = styled.div`
    font-family: Optima regular font;
    color: white;
    text-align: right;
    margin-right: 1%;
    position: absolute;
    bottom: 5px;
    right: 0;

    ${mediaQueries.mobile} {
        margin-right: 1%;
        font-size: 12px;
        padding-bottom: 10px;
  }
`


export default function BannerIllo(props)
{
    const Container = styled.div`
    display: block;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #${props.background_color};
    padding-bottom: 0px;
    img {
        width: 100%;
        padding-bottom: 0px;
    }
`
    return (
        <Container >
            <img src = {props.illo_url} alt="banner illustration"></img>
            <Credits>
                {`${props.credit}`}
            </Credits>
        </Container>
    )
}
